import { use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { G_GRAPH_BUTTON__image_invert_colors } from '@/pages/page_generation/layouts/nodes/node/fields/image/_base/_buttons/G_GRAPH_BUTTON__image_invert_colors';
import { HOOK_IMAGE__get_image_mask_for } from '@/utils/_methods/FN_IMAGE__get_image_mask_for';

export function G_BUTTON__image_edit__mask_invert() {
  /*
   * STORE
   */
  const { g_image_edit__field: field } = use_slice_ui(['g_image_edit__field']);
  const field_mask = HOOK_IMAGE__get_image_mask_for(field);

  /*
   * HTML
   */

  if (field_mask.is_stub()) return <PLACEHOLDER_bar_line />;
  if (!field_mask.image__is_initialized) return <PLACEHOLDER_bar_line />;

  return <G_GRAPH_BUTTON__image_invert_colors field={field_mask} size={'w-full-h-10'} variant={'outline-on-bar'} text="Invert Mask" />;
}
